// Meta description for a checklist page: the snippet Google shows under the title.
// Shared by the server render (server/seo/checklist.js) and the app, so both send the same text.
// CommonJS so the server can require it.
/* global module */

// Google shows roughly this many characters before cutting the snippet off
const MAX_LENGTH = 155;
const SUFFIX = 'Fully referenced neurology checklist.';
// Short items read as a list ("Weight loss, Fasting"); longer ones, or ones that start like
// a sentence ("It arises from the dorsal pons"), are joined as sentences
const LIST_ITEM_MAX = 60;
const SENTENCE_START = /^(this|these|those|it|its|they|there|the|onset|patients?)\b/i;

function clean(text) {
  return String(text || '').replace(/\s+/g, ' ').trim();
}

function withoutEndPunctuation(text) {
  return text.replace(/[\s.,;:]+$/, '');
}

// As many whole parts as fit in budget, joined with separator
function takeWithin(parts, budget, separator) {
  const taken = [];
  let length = 0;
  for (const part of parts) {
    const added = (taken.length ? separator.length : 0) + part.length;
    if (length + added > budget) break;
    taken.push(part);
    length += added;
  }
  return taken.join(separator);
}

function firstSectionItems(sections) {
  const first = (Array.isArray(sections) ? sections : []).find((section) => (
    section && Array.isArray(section.list_items) && section.list_items.length
  ));
  if (!first) return [];
  return first.list_items
    .map((item) => withoutEndPunctuation(clean(item && item.title && item.title.text)))
    .filter(Boolean);
}

function bodyWithin(items, budget) {
  if (budget <= 0 || !items.length) return '';
  const listLike = items.filter((item) => item.length <= LIST_ITEM_MAX && !SENTENCE_START.test(item));
  if (listLike.length >= items.length / 2) {
    const list = takeWithin(items.filter((item) => item.length <= LIST_ITEM_MAX), budget - 1, ', ');
    return list ? `${list}.` : '';
  }
  return takeWithin(items.map((item) => `${item}.`), budget, ' ');
}

function checklistDescription(title, sections) {
  const name = withoutEndPunctuation(clean(title));
  const lead = `${name}.`;
  const items = firstSectionItems(sections)
    // the first item often repeats the title
    .filter((item) => item.toLowerCase() !== name.toLowerCase());

  const withSuffix = bodyWithin(items, MAX_LENGTH - lead.length - SUFFIX.length - 2);
  if (withSuffix) return `${lead} ${withSuffix} ${SUFFIX}`;

  const body = bodyWithin(items, MAX_LENGTH - lead.length - 1);
  if (body) return `${lead} ${body}`;

  const fallback = `${lead} ${SUFFIX}`;
  return fallback.length <= MAX_LENGTH ? fallback : lead;
}

module.exports = { checklistDescription };
